import Repository from "./Repository";

const GET_KARUNAPOINT = "getKarmaPointByUserId";

export default {
  getKarunaPointByUserId(payload) {
    return Repository.post(transformRoute(GET_KARUNAPOINT), payload);
  },
};

const transformRoute = (route) => {
  return `karmaPoint/${route}`;
};
